
import { ElMessage } from "element-plus";
import { getEnum, login } from "@/api/index";
import Uploadimg from "@/components/uploadimg/Index.vue";
import { useStore } from "vuex";
import { ElForm } from "element-plus";

import { putGaller } from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增数字展厅",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    Uploadimg,
  },
  emits: ["close"],
  setup(opt, contex) {
    const ruleFormRef = ref(ElForm);
    let isEdit = false;
    let show = opt.open;
    const store = useStore();

    const dataMap: any = reactive({
      ruleForm: {
        title: "",
        description: "",
        fileId:'',
        linkUrl:'',
        fileName:'',
        sortNum: "",
      },
      rules: {
        title: [
          { required: true, message: "请输入展厅名", trigger: "blur" },
        ],
        linkUrl: [
          { pattern: /^((ht|f)tps?):\/\/[\w-]+(\.[\w-]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/, message: "请输入正确的URL地址", trigger: "blur",},
        
        ],
      },

      async putNewData() {
        const res = await putGaller(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });

    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
      if(opt.row.fileName) dataMap.ruleForm.fileUrl =  localStorage.getItem("fileUrel") + opt.row.fileName;
    }

    const submitForm = () => {
      const form = unref(ruleFormRef);
      form.validate((valid: any) => {
        if (valid) {
          dataMap.putNewData();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const close = () => {
      const form = unref(ruleFormRef);
      contex.emit("close", false);
    };

    const onSuccess = (val: any) => {
      dataMap.ruleForm.fileId = val.id;
      dataMap.ruleForm.fileName = val.fileName;
    };


    return {
      show,
      store,
      isEdit,
      ruleFormRef,
      submitForm,
      onSuccess,
      close,
      ...toRefs(dataMap),
    };
  },
});
